"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
const b_1 = __importDefault(require("b_"));
const button_styles_1 = __importDefault(require("./button.styles"));
const b = b_1.default.with('button');
const tempFunc = () => null;
// eslint-disable-next-line react/display-name
const Button = (0, react_1.forwardRef)((props, ref) => {
    const { view, size, children, disabled, mix, onClick, checked, type = 'button', onMouseDown = tempFunc, onMouseUp = tempFunc } = props, rest = __rest(props, ["view", "size", "children", "disabled", "mix", "onClick", "checked", "type", "onMouseDown", "onMouseUp"]);
    const className = `${b('', {
        view,
        size,
        checked: checked ? 'yes' : 'no',
        disabled: disabled ? 'yes' : 'no'
    })} ${mix}`.trim();
    const stylesApplied = (0, button_styles_1.default)({
        size,
        disabled,
        checked,
        view
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("button", Object.assign({ type: type, css: stylesApplied, ref: ref, onMouseUp: onMouseUp, onMouseDown: onMouseDown, "data-value": props['data-value'], disabled: disabled, onClick: onClick, className: className }, rest, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: b('text') }, { children: children })) })) }));
});
exports.default = Button;
